/**
 * Pirate Raid Flavor Text System
 * 
 * Dynamic descriptions for pirate raids that reference character conflicts
 * and world lore without exposition dumping.
 */

export interface RaidFlavorTemplate {
  tier: string;
  descriptions: string[];
}

const raidFlavorTemplates: RaidFlavorTemplate[] = [
  {
    tier: 'skirmish',
    descriptions: [
      'A small pirate crew raids the settlement—likely mercenaries working for a larger faction.',
      'Local pirates test the settlement\'s defenses. This happens more often these days.',
      'Opportunistic raiders strike. The Navy\'s stretched too thin to respond quickly.',
    ],
  },
  {
    tier: 'raid',
    descriptions: [
      'A coordinated pirate assault. Scarlet Jack\'s influence spreads—organized, disciplined.',
      'Multiple pirate crews work together. Unity is rare among them. Something\'s changed.',
      'The Navy\'s grip weakens. Raiders grow bolder. Kross won\'t tolerate this for long.',
      'Rival pirate factions clash here, using the settlement as their battleground.',
    ],
  },
  {
    tier: 'invasion',
    descriptions: [
      'A full-scale invasion. This is what Admiral Kross warned about. The pirate factions are uniting.',
      'The settlement is under siege. Scarlet Jack\'s vision of pirate unity becomes reality.',
      'A catastrophic assault. The Navy cannot respond in time. This is a turning point.',
      'The rift storms rage while pirates strike. Chaos consumes the settlement.',
    ],
  },
];

/**
 * Get a random flavor description for a raid
 */
export const getRaidFlavorText = (tier: string): string => {
  const template = raidFlavorTemplates.find(t => t.tier === tier);
  if (!template) {
    return 'A pirate raid is underway.';
  }
  return template.descriptions[Math.floor(Math.random() * template.descriptions.length)];
};

/**
 * Get raid title with flavor
 */
export const getRaidTitle = (islandName: string, tier: string): string => {
  const tierUpper = tier.toUpperCase();
  return `PIRATE RAID - ${islandName} [${tierUpper}]`;
};
